module.exports = __webpack_public_path__ + "static/img/2_1.f60b9ee4.jpg";